<div
  *ngIf="src"
  [innerHtml]="sanitizedSrc"
  class="{{ classes }}"
></div>